import { sendGTMEvent } from "@next/third-parties/google";

export const SendGTMEvent = (event: string, value: any) => {
  sendGTMEvent({ event: "clear", value: null });
  sendGTMEvent({ event, value });
};
